<template>
  <el-scrollbar wrap-class="scrollbar-wrapper-y">
    <div>
      <div class="flex">
        <div class="el-header header-container">
          <div class="header-left">
              <el-button
              type="success"
              icon="el-icon-circle-plus"
              @click="eduitNameRole('')"
            >创建角色</el-button>
          </div>
          <div class="header-right">
              <!-- <span class="role-name">角色名称:</span> -->
              <el-input
                v-model="keyword"
                @keyup.enter.native="currentPage=1;flush();"
                placeholder="输入角色搜索"
              />
              <el-button type="primary" size="mini" @click="currentPage=1;flush();">查询</el-button>
          </div>
        </div>      
        <!-- <el-button type="danger" size="mini" icon='el-icon-delete' @click='delRole'>删除角色</el-button> -->
      </div>
      <el-table
        ref="multipleTable"
        :data="roleData"
        tooltip-effect="dark"
        border
        align="center"
        :stripe="true"
        size="mini"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column
                        type="selection"
                        align='center'
                >
        </el-table-column>-->
        <el-table-column width="80" align="center" label="序号">
          <template slot-scope="scope">{{(currentPage - 1 ) * pageSize + scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="id" label="权限ID" align="center"></el-table-column>
        <el-table-column prop="name" label="角色名称" align="center"></el-table-column>
        <el-table-column prop="creator" label="创建人" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center" width="300">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="eduitNameRole(scope.row)">编辑</el-button>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              @click="delRole(scope.row)"
            >删除</el-button>
            <el-button
              v-role-btn="['admin']"
              @click="roleCheck(scope.row)"
              type="primary"
              size="mini"
            >权限分配</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page_footer_box"
        @size-change="currentPage=1;flush();"
        @current-change="flush"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size.sync="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <RoleNameEduit :config="config" @close="flush"></RoleNameEduit>
    <RoleModuleMapping ref="roleModuleDialog" :config="configModuleDialog"></RoleModuleMapping>
  </el-scrollbar>
</template>

<script>
import RoleNameEduit from "../../components/dialog/RoleNameEduit";
import RoleModuleMapping from "../../components/dialog/RoleModuleMapping";
import * as sysApi from "../../services/sys";
import { dateFormat } from "@/utils/utils";

export default {
  components: {
    RoleNameEduit,
    RoleModuleMapping
  },
  data() {
    return {
      roleData: [],
      keyword: "",
      systemSelect: "",
      show: false,
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      config: {
        show: false,
        width: 500,
        title: "",
        data: {}
      },
      configModuleDialog: {
        show: false,
        width: 500,
        title: "",
        data: {},
        menuTree: []
      }
    };
  },
  mounted() {
    this.flush();
  },
  methods: {
    async flush() {
      let result = await this.$promission.get("/api/Roles", {
        page: this.currentPage,
        pageSize: this.pageSize,
        searchText: this.keyword
      });
      result.roles.map(function (item, index) {
              item.createTime= dateFormat("YYYY-mm-dd",item.createTime);
          });
      this.roleData = result.roles;
      this.total = result.totalCount;

      sysApi.menuList({
        AppCode: process.env.VUE_APP_CODE
      }).then(res => {
        this.configModuleDialog.menuTree = res;
      });
    },
    handleSelectionChange(val) {
      this.selectitems = val;
    },
    delRole(row) {
      let _this = this;
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$promission.post("/api/Roles/Delete/" + row.id).then(res => {
          if (_this.roleData.length == 1 && _this.currentPage)
            _this.currentPage--; //全部删除返回上一页
          _this.flush();
          _this.$message({
            showClose: true,
            type: "success",
            message: "删除成功!"
          });
        });
      });
    },
    roleCheck(row) {
      this.configModuleDialog.title = "权限设置";
      this.configModuleDialog.data = Object.assign({}, row);
      this.configModuleDialog.show = true;

      this.$refs.roleModuleDialog.loadRoleModuleMapping(row.id);
    },
    // 角色名编辑
    eduitNameRole(row) {
      if (row) {
        this.config.title = "编辑角色名称";
        this.config.data = Object.assign({}, row);
      } else {
        this.config.title = "创建角色名称";
        this.config.data = {};
      }
      this.config.show = true;
    }
  }
};
</script>

<style lang='scss' scoped>
  .page_footer_box {
    float: right;
    margin: 3px 10px;
  }
  .header-container {
    display: flex;
    justify-content: space-between;
    .header-left {
      text-align: left;
      width: 30%;
    }
    .header-right{
      text-align: right;
      width: 70%;
    }
    .role-name {
      margin-right: 8px;
      display: inline-block;
      line-height: 60px;
    }
    .el-input {
      margin-right: 8px;
      width: 60%;
    }
    .el-button--primary {
      margin-top: 10px;
      height: 40px;
    }
  }

  .flex {
    padding: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/views/sys/RoleManagement.vue